import React from 'react'

const NoRecordFound = () => {
  return (
  <div className='text-center fs-6 fw-bold pb-3'>
    No Record Found
    </div>
  )
}

export default NoRecordFound